import { Input } from '@/components/ui/input'
import { useTranslation } from '@/shared/hooks/useTranslation'

type QuizTextAnswerProps = {
  value: string
  disabled?: boolean
  onChange: (value: string) => void
}

export function QuizTextAnswer({ value, disabled, onChange }: QuizTextAnswerProps) {
  const { t } = useTranslation()

  return (
    <Input
      value={value}
      disabled={disabled}
      placeholder={t('quests.quiz.textPlaceholder')}
      onChange={event => onChange(event.target.value)}
    />
  )
}
